$(() => {
  const detailsBtn = document.getElementById("scroll-details-btn");
  const detailsSection = document.querySelector('[data-section="details"]');
  handleScrollToSection(detailsBtn, detailsSection);
  function handleScrollToSection(triggerButton, section) {
    if (!triggerButton) {
      return;
    }
    triggerButton.addEventListener("click", (event) => {
      const offset = 96;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  }
});
